import type { IconData } from '@stacksjs/iconify-core'

export const navigationArrowOffFlat: IconData = {
  "body": "<g fill=\"none\" fill-rule=\"evenodd\" clip-rule=\"evenodd\"><path fill=\"#8fbffa\" d=\"M41.522 2.742a3.33 3.33 0 0 1 3.736 3.736c-.812 6.399-3.062 14.22-5.634 21.262c-2.568 7.033-5.511 13.434-7.768 16.971c-.664 1.04-1.765 1.532-2.863 1.43c-1.068-.099-2.034-.744-2.58-1.74l-8.078-14.736L3.6 21.588c-.997-.546-1.642-1.512-1.741-2.58c-.102-1.098.39-2.2 1.43-2.863c3.537-2.257 9.938-5.2 16.97-7.768c7.043-2.572 14.864-4.822 21.263-5.634Z\"/><path fill=\"#2859c5\" d=\"M5.232 1.232a2.5 2.5 0 0 1 3.536 0l38 38a2.5 2.5 0 0 1-3.536 3.536l-38-38a2.5 2.5 0 0 1 0-3.536\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default navigationArrowOffFlat
